import { IDeleteStoryEmbedResponse } from '../../../types';

/**
 * Preserve the prior storyEmbeds.createdAt when a matching row was deleted.
 * When the PK delete returns null (no bookkeeping row) or a null timestamp,
 * keep the caller-supplied fallback (typically a freshly generated ISO time).
 */
export function resolveStoryEmbedCreatedAt(
  deleteResponse: IDeleteStoryEmbedResponse | null | undefined,
  fallbackCreatedAt: string
): string {
  return deleteResponse?.data?.delete_storyEmbeds_by_pk?.createdAt ?? fallbackCreatedAt;
}
